module.exports = __webpack_public_path__ + "img/favicon.4dd3de8f.png";